<template>
  <el-config-provider
    :locale="locale"
    :message="messageConfig"
  >
    <div class="c_p_relative">
      <el-container v-if="route.name !== 'login'">
        <el-header>
          <nav-header />
        </el-header>
        <div v-show="appName !== 'admin'">
          <nav-drawer />
        </div>
      </el-container>
      <router-view :class="{ main_content: route.name !== 'login' }" />
      <div id="subApp" />
    </div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import NavHeader from '@/layout/AppHeader/index.vue'
import NavDrawer from '@/layout/AppNavDrawer/index.vue'
import { useRoute } from 'vue-router'
import shared from '@/micro/shared'
import { computed, reactive } from 'vue'
import locale from 'element-plus/es/locale/lang/zh-cn'

const messageConfig = reactive({
  max: 3,
})

const route = useRoute()
const appName = computed(() => shared.getAppName())
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#subApp {
  width: 100%;
}

.el-header {
  background-color: @whiteColor;
  // color: @whiteColor;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid @mainBorderColor;
}

.main_content {
  height: calc(100vh - 60px) !important;
}
</style>
